export default __webpack_public_path__ + "static/media/checkicon.f5bec4dc.svg";